import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

export const isDeliveryPickupBrandRefresh = () => isBrandRefreshEnabled();

export const getWidgetRegionProps = () =>
  isBrandRefreshEnabled() ? { 'data-region': 'delivery-pickup-widget' } : {};

export const getWidgetPartProps = (part) =>
  isBrandRefreshEnabled() ? { 'data-part': part } : {};

export const getMapPinIcon = (legacyMapPinIcon, brandRefreshMapPinIcon) =>
  isBrandRefreshEnabled() ? brandRefreshMapPinIcon : legacyMapPinIcon;

export const getCurrentLocationIcon = (legacyIcon, brandRefreshCurrentIcon) =>
  isBrandRefreshEnabled() ? brandRefreshCurrentIcon : legacyIcon;

export const getMapLightIcon = (legacyMapLightIcon, brandRefreshMapLightIcon) =>
  isBrandRefreshEnabled() ? brandRefreshMapLightIcon : legacyMapLightIcon;

export const getClearDarkIcon = (legacyClearDarkIcon, brandRefreshClearDarkIcon) =>
  isBrandRefreshEnabled() ? brandRefreshClearDarkIcon : legacyClearDarkIcon;

export const getNationwideIcon = (legacyNationwideIcon, brandRefreshNationwideIcon) =>
  isBrandRefreshEnabled() ? brandRefreshNationwideIcon : legacyNationwideIcon;
